/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Irrigation_Run_Off_RetryInputs */

const vi_irrigation_run_off_retry = /** @type {(inputs: Irrigation_Run_Off_RetryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chưa tắt được, đang thử lại (${i?.count} lần)`)
};

/**

* @param {Irrigation_Run_Off_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_off_retry = /** @type {((inputs: Irrigation_Run_Off_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Off_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_off_retry(inputs)
});